import { getConfig } from '@/config/appConfig';
import {
  mockAuthService,
  mockFotoService,
  mockHistorieService,
  mockRegistratieService,
  mockWoningService,
} from './mockService';
import { maakPdokWoningService } from './pdokBagService';
import { supabaseAuthService } from './supabase/supabaseAuthService';
import { supabaseFotoService } from './supabase/supabaseFotoService';
import { supabaseHistorieService } from './supabase/supabaseHistorieService';
import { supabaseRegistratieService } from './supabase/supabaseRegistratieService';
import type {
  AuthService,
  FotoService,
  HistorieService,
  RegistratieService,
  WoningService,
} from './types';

/**
 * Kiest de implementatie op basis van de configuratie. De rest van de app
 * importeert alleen deze factory, nooit een concrete service.
 */

let woningServiceCache: WoningService | null = null;

function gebruiktSupabase(): boolean {
  return getConfig().dataProvider === 'supabase';
}

export function getRegistratieService(): RegistratieService {
  return gebruiktSupabase() ? supabaseRegistratieService : mockRegistratieService;
}

export function getFotoService(): FotoService {
  return gebruiktSupabase() ? supabaseFotoService : mockFotoService;
}

export function getAuthService(): AuthService {
  return gebruiktSupabase() ? supabaseAuthService : mockAuthService;
}

export function getHistorieService(): HistorieService {
  return gebruiktSupabase() ? supabaseHistorieService : mockHistorieService;
}

export function getWoningService(): WoningService {
  if (getConfig().bagProvider !== 'pdok') return mockWoningService;
  if (!woningServiceCache) woningServiceCache = maakPdokWoningService();
  return woningServiceCache;
}

/** Forceert dat services opnieuw worden gekozen na een configuratiewijziging. */
export function resetServices(): void {
  woningServiceCache = null;
}
